$(function(){
	$(".flick-slide").flickSlide({
		createPager: "thumbnail",
		repeat: true,
		timer: 5
	});
});


/*****************
 ** WEBPACK FOOTER
 ** ./js/_top.js
 ** module id = 0
 ** module chunks = 2
 **/